import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss"
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import QrcodeTable from './components/QrcodeTable';
import QrDetails from './components/QrDetails';
import GenerateQrcode from './components/GenerateQrcode';
import QRCodeSettingModal from '../../modalComponents/QRCodeSettingModal';
import Exported from '../../service/endpoints';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { Toast } from '../../service/toast';
import request from '../../service';
import GetUserPermission from '../../component/GetUserPermission';

const Qrcode = () => {
    const [viewDetails, setViewDetails] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [isGenerated, setIsGenerated] = useState(false)
    const [QRSetupModal, setQRSetupModal] = useState(null)
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [QRDetails, setQRDetails] = useState(null)
    const [activeTab, setActiveTab] = useState("Individual")
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const qrTabs = ["Individual", "Bulk"];
    const addPermission = GetUserPermission({ key: 'add' });


    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('id');
        const type = searchParams.get('type');
        setQRDetails(null)
        if (id) {
            setViewDetails(true);
            getViewDetails(id)
            setIsGenerated(false);
        } else if (type === 'generateQrcode') {
            setSelectedInfo(null);
            setViewDetails(false);
            setIsGenerated(true);
        } else {
            setSelectedInfo(null);
            setViewDetails(false);
            setIsGenerated(false);
        }
    }, [location.search]);

    useEffect(() => {
        if (viewDetails && selectedInfo == null && location?.search) {
            const searchParams = new URLSearchParams(location.search);
            const id = searchParams.get('id');
            if (id) {
                getUserInfo(id)
            }
        }
    }, [viewDetails, selectedInfo, location])

    const getUserInfo = async (id) => {
        let url = `${Exported.Endpoints.getQRList}`
        let paramsObj = {
            isBulk: activeTab === 'Individual' ? 0 : 1
        }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setSelectedInfo(res?.data?.data?.list?.filter((x) => x?.id == id)?.at(0))
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const getViewDetails = async (id) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getQRIndividualList}`;
        let paramsObj = {
            id
        }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setQRDetails(res?.data?.data)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }


    const handleChange = (value) => {
        setSearchInput(value)
    }

    const redirectBack = () => {
        navigate(`/admin/qrcode`)
    }

    const redirectTo = () => {
        setIsGenerated(true)
        navigate(`?type=generateQrcode`)
    }

    const handleQRSetupClose = () => {
        setQRSetupModal(null)
    }

    return (
        <>
            {viewDetails && !isGenerated ? (
                <QrDetails detailInfo={QRDetails} activeTab={activeTab} selectedInfo={selectedInfo} setSelectedInfo={setSelectedInfo} setQRSetupModal={setQRSetupModal} />
            ) : !viewDetails && isGenerated ? (
                <GenerateQrcode activeTab={activeTab} />
            ) : (
                <div className={`${classes.manageUserWrapper}`}>
                    <div className={`w-[100%] flex items-center justify-between`}>
                        <div className={`layout-title`}>QR Code</div>
                        <div className='flex items-center'>
                            <SearchBox
                                value={searchInput}
                                onChange={handleChange}
                                placeholder={'Find by product name, date...'}
                            />
                            {addPermission &&
                                <Button text={"Generate QR Code"} className={'ml-5'} smallBtn onClick={() => redirectTo()} />
                            }
                        </div>
                    </div>
                    <div className={`${classes.userHeaderList} w-[100%] flex items-center`}>
                        {qrTabs.map((item) => (
                            <div
                                key={item}
                                className={`${classes.userTab} ${activeTab === item ? classes.activeTab : ''}`}
                                onClick={() => setActiveTab(item)}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                    <div>
                        <QrcodeTable searchInput={searchInput} activeTab={activeTab} setSelectedInfo={setSelectedInfo} setQRSetupModal={setQRSetupModal} />
                    </div>
                </div>
            )}
            {/* {QRSetupModal ?
                <QRCodeSettingModal isOpen={QRSetupModal ? true : false} qrInfo={QRSetupModal} closePopUp={handleQRSetupClose} activeTab={activeTab} />
                : null} */}
        </>
    );

}

export default Qrcode